var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('v-main',{staticClass:"ma-0 d-flex h-100 w-100 justify-center align-center"},[_c('div',{staticClass:"text-center title"},[_vm._v("Se vienen cositas...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }